export default __webpack_public_path__ + "static/media/pending-icon.4d2af174.svg";